
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexQo4ByY_45uDyO_3BaQnUbWC_vSXlGUCoG_45odeodnoYgHkMeta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/index.vue?macro=true";
import { default as index7vmr3AkUWIhnVlIUcgLlyQExT3zAbIWSJEYV7bRFDa8Meta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/faq/index.vue?macro=true";
import { default as index_45xYjj5TEFfl1bAsZ_ChYny3_H3sTDit_LaVB9flRXK8Meta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/pro/index.vue?macro=true";
import { default as indexmg0vfjhB4f1MraqjRTZP0I34ySotz9CiAItkA_xvzSkMeta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/cart/index.vue?macro=true";
import { default as indexF0TwjI5xH4CFJHKLsRSsDCDEak92CVZFLBFugHKUMfMMeta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/news/index.vue?macro=true";
import { default as _91slug_93xvARGJgtwCmLp38mmZbQrtTJMw46o0uLfWg3jQQxL3UMeta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/pro/[slug].vue?macro=true";
import { default as indextTLvR1fw6n3zJKsYPNKEtbo59h5Z9tn62pBuScP3P68Meta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/rent/index.vue?macro=true";
import { default as indexjUHk7dtGJprLZhBQnfL8_Zt61eWUIXYcn8MHYaTZKqMMeta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/about/index.vue?macro=true";
import { default as index4bJ38Lp4hqJqBDkr54Tyg4g6G0P4_45efm1VZU0EXOoWkMeta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/media/index.vue?macro=true";
import { default as _91slug_93CFf3CEiyS_u5NKvXzloJF_D2HVcD1saTHBw_45ldd6MZ0Meta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/news/[slug].vue?macro=true";
import { default as index2HAq668NYA9bP4XJO02Wi_45jo56b_45H4tRItgFMLeQJvAMeta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/videos/index.vue?macro=true";
import { default as indexZlDQ4ALb058UMQqVdZm65hyo6sSeOuVqZ9NDFYhVvjYMeta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/catalog/index.vue?macro=true";
import { default as indexXeQk3ynvwArSsYyiqvDrRTVmDdYED2GONtsn3k908ogMeta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/reviews/index.vue?macro=true";
import { default as indexp_xRnnL2SuJ3FiPoPZyLHdABFUdddIfPXLS9kC8I2k0Meta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/contacts/index.vue?macro=true";
import { default as index6niVBMXCPiLbe3jm0EjmTGqfZ5LvdX0DEeygGnbT7NcMeta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/portfolio/index.vue?macro=true";
import { default as indexOUArMYw6c_yxkutytHjGA8y2L6CPITgdonzI9JmIzrQMeta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/solutions/index.vue?macro=true";
import { default as _91slug_93dst0o_45zOP9BRayGnbSHwlNdBk8Fn65AlwYo8Nl_45BQH4Meta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/portfolio/[slug].vue?macro=true";
import { default as _91slug_93nP4mvt9FxaGZFeNThigOpB5_QaYWeUgpvtgAZ1mZCj4Meta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/solutions/[slug].vue?macro=true";
import { default as indexHQ_McS1ZQSDPMS1pUxR6mc9Wy8_P2kEXYkhQqTH8JjgMeta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/[direction]/index.vue?macro=true";
import { default as _91product_93y6Uee6PKoMHx1gjzb237ODmijQ8xlmZx44WnVBOj1JcMeta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/catalog/[product].vue?macro=true";
import { default as indexdpJT591RXuyi6GLpS7jB2rF5a7NCIr03K7bPmHKH2nEMeta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/create-order/index.vue?macro=true";
import { default as _91subcategory_93GL6MK_37_4501wjoGVGyJEl55XwxqUNajm1bBde_UC9QgMeta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/[direction]/[subcategory].vue?macro=true";
import { default as indexow5t97H3kfquGZHbmXyzwUZQh0d54Dltnfy6GSBsbroMeta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/delivery-and-payment/index.vue?macro=true";
import { default as indexC34Pe0PFR0MKAycg3jhruo2biDfkeVzCDggRp4EilSoMeta } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/warranty-and-service/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/index.vue")
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/faq/index.vue")
  },
  {
    name: "pro",
    path: "/pro",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/pro/index.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/cart/index.vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/news/index.vue")
  },
  {
    name: "pro-slug",
    path: "/pro/:slug()",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/pro/[slug].vue")
  },
  {
    name: "rent",
    path: "/rent",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/rent/index.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/about/index.vue")
  },
  {
    name: "media",
    path: "/media",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/media/index.vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/news/[slug].vue")
  },
  {
    name: "videos",
    path: "/videos",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/videos/index.vue")
  },
  {
    name: "catalog",
    path: "/catalog",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/catalog/index.vue")
  },
  {
    name: "reviews",
    path: "/reviews",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/reviews/index.vue")
  },
  {
    name: "contacts",
    path: "/contacts",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/contacts/index.vue")
  },
  {
    name: "portfolio",
    path: "/portfolio",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/portfolio/index.vue")
  },
  {
    name: "solutions",
    path: "/solutions",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/solutions/index.vue")
  },
  {
    name: "portfolio-slug",
    path: "/portfolio/:slug()",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/portfolio/[slug].vue")
  },
  {
    name: "solutions-slug",
    path: "/solutions/:slug()",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/solutions/[slug].vue")
  },
  {
    name: "direction",
    path: "/:direction()",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/[direction]/index.vue")
  },
  {
    name: "catalog-product",
    path: "/catalog/:product()",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/catalog/[product].vue")
  },
  {
    name: "create-order",
    path: "/create-order",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/create-order/index.vue")
  },
  {
    name: "direction-subcategory",
    path: "/:direction()/:subcategory()",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/[direction]/[subcategory].vue")
  },
  {
    name: "delivery-and-payment",
    path: "/delivery-and-payment",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/delivery-and-payment/index.vue")
  },
  {
    name: "warranty-and-service",
    path: "/warranty-and-service",
    component: () => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/pages/@cromi.ru/warranty-and-service/index.vue")
  }
]